import { Chakra } from "@airhelp/react-ui-components";
import { useLanguage, useTranslations } from "contexts/LocalizationContext/hooks";
import getPageUrl from "utils/getPageUrl";

import SingleLink from "./SingleLink";

const { Flex, Text } = Chakra;

const Links = () => {
  const language = useLanguage();
  const translations = useTranslations();
  return (
    <Flex
      flexWrap="wrap"
      flexDir={{ base: "column", md: "row" }}
      align={{ base: "start", md: "center" }}
      justify="space-between"
      color="greyscale.700"
    >
      <Flex>
        <Flex flexDir={{ base: "column", md: "row" }} mr={{ base: 10, md: 0 }}>
          <SingleLink path={getPageUrl(language, "airPassengerRights")} translationKey="menu_air_passenger_rights" />
          <SingleLink path={getPageUrl(language, "help")} translationKey="menu_help" />
        </Flex>
        <Flex flexDir={{ base: "column", md: "row" }} mr={{ base: 10, md: 0 }}>
          <SingleLink path={getPageUrl(language, "terms")} translationKey="terms_link_title" />
          <SingleLink path={getPageUrl(language, "privacy")} translationKey="terms_privacy_link_title" />
        </Flex>
      </Flex>
      <Text py={7} color="greyscale.500" fontSize="sm">
        {translations("menu_copyright", { "%current-year%": new Date().getFullYear() })}
      </Text>
    </Flex>
  );
};

export default Links;
